import { DAY_UNIT } from '../constants';

import leaveTypesSelectionRowUrl from './leaveTypesSelectionRowComponent.html';

class leaveTypesSelectionRowController {
  constructor(Authentication, LeaveService) {
    'ngInject';

    Object.assign(this, { Authentication, LeaveService });
  }

  $onInit() {
    this.units = this.Authentication.user.orgSettings.leaveCapUnit;
  }

  get usedTimeOffLabel() {
    return this.LeaveService.getUsedLeaveDisplayDuration(this.timeOffType, this.userLeaveStatus);
  }

  get displayedUnits() {
    if (!this.capsForType) {
      return '';
    }

    return this.units === DAY_UNIT ? 'd' : 'h';
  }

  get capsForType() {
    return this.LeaveService.getCapForType(this.timeOffType, this.userLeaveCaps);
  }

  get showCap() {
    return this.LeaveService.isCapSet(this.timeOffType, this.userLeaveCaps);
  }

  get isLimitReached() {
    return this.LeaveService.isLimitReached(
      this.timeOffType,
      this.userLeaveStatus,
      this.userLeaveCaps
    );
  }

  get isGlobal() {
    return this.LeaveService.isGlobal;
  }

  get tooltip() {
    const usedMinutes = this.LeaveService.getLeaveTypeUsed(this.timeOffType, this.userLeaveStatus);
    const displayUnit = this.LeaveService.units === DAY_UNIT ? 'days' : 'hours';
    return `Taken ${this.LeaveService.getDescriptiveLabel(usedMinutes)} of ${
      this.capsForType
    } ${displayUnit}`;
  }
}

export default {
  controller: leaveTypesSelectionRowController,
  controllerAs: 'ctrl',
  templateUrl: leaveTypesSelectionRowUrl,
  bindings: {
    onTypeClick: '&',
    timeOffType: '<',
    userLeaveStatus: '<',
    userLeaveCaps: '<',
  },
};
